// utils/cart.js
// Client-side cart stored in localStorage as an array of publication ids.
// Publication details are hydrated server-side via the batch endpoint
// POST /upload/publications/ when needed.

const CART_KEY = 'datavault_kg_cart';

export function getCartIds() {
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

function writeCartIds(ids) {
  localStorage.setItem(CART_KEY, JSON.stringify(ids));
}

export function addToCart(id) {
  if (!id) return { added: false };
  const ids = getCartIds();
  if (ids.includes(id)) return { added: false };
  ids.push(id);
  writeCartIds(ids);
  return { added: true };
}

export function removeFromCart(id) {
  const ids = getCartIds();
  const next = ids.filter((x) => x !== id);
  if (next.length === ids.length) return false;
  writeCartIds(next);
  return true;
}

export function removeManyFromCart(idsToRemove) {
  const removeSet = new Set(idsToRemove);
  if (removeSet.size === 0) return 0;
  const ids = getCartIds();
  const next = ids.filter((id) => !removeSet.has(id));
  writeCartIds(next);
  return ids.length - next.length;
}

export function clearCart() {
  localStorage.removeItem(CART_KEY);
}
